import { Box } from '@bechtel/gds';
import styled from 'styled-components';

export const ReturnItemStyled = styled.div`
  width: 100%;
`;

export const ToolCatalogMainItemStyled = styled(ReturnItemStyled)`
  background-color: ${({ theme }) => theme.colors.grey[100]};
`;

export const DetailSectionStyled = styled(Box)`
  width: 142px;
`;
